/* eslint-disable no-useless-escape */
import isEmailValidator from 'validator/lib/isEmail';
import { errorTypes } from "../types/errorTypes";
export const isEmail = _ref => {
  let {
    required,
    value = ''
  } = _ref;
  const trimmed = value.replace(/\s+$/, '');
  const allowedChars = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,64})+$/;
  if (trimmed) {
    if (isEmailValidator(trimmed) && allowedChars.test(trimmed)) {
      return '';
    }
    return errorTypes.invalid;
  }
  if (required) {
    return errorTypes.required;
  }
  return '';
};